@import '../../../theme.scss';

verdocs-auth {
  font-family: $verdocs-primary-font;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  .form {
    width: 350px;
    display: flex;
    padding: 20px;
    max-width: 90%;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: center;
    background: $verdocs-grey-4;
  }

  .logo {
    width: 128px;
    max-width: 100%;
    margin: 20px 0 30px;
  }

  h3 {
    color: $verdocs-grey-0;
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    line-height: 1.75;
    margin: 0;
  }

  em {
    font-size: 14px;
    margin: 15px 0;
  }

  .buttons {
    gap: 20px;
    margin: 20px 0 0 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .status-result {
    display: none;

    &.debug {
      white-space: pre-wrap;
      font-size: 14px;
      background: #fff;
      padding: 10px;
      display: block;
      flex-direction: row;
      justify-content: center;
    }
  }

  form {
    width: 100%;
  }

  verdocs-text-input {
    margin-bottom: 10px;
  }

  .account-option {
    gap: 8px;
    margin: 20px 0 8px 0;
    display: flex;
    flex-direction: row;
  }

  p {
    color: $verdocs-grey-0;
    margin: 1em 0;
    font-size: 14px;
  }

  // Our <p>s are in a flex layout which prevents margins from collapsing because each item creates its own row
  p + p {
    margin-top: 0;
  }

  verdocs-help-icon {
    margin-top: 18px;
    display: flex;
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
  }

  .already-have {
    color: $verdocs-grey-0;
    margin: 0.5em 0;
    font-size: 14px;
    text-align: center;
  }

  .service-agreement {
    font-size: 12px;
    color: #777;

    a {
      color: $verdocs-grey-0;
    }
  }
}
